import React from 'react';
import { Button, getClassNameFactory } from '@dcl/ui';
import { IEmailArticleProps } from './types';
import './index.css';
import { constant } from './constants';
import EmailArticleIcon from './EmailArticleIcon';
import { triggerAnalyticsEvent } from '../../utils/analytics';
import {
  ButtonColor,
  ButtonKind,
  IconPosition,
} from '@dcl/ui/dist/elements/Button';

export const EmailArticle: React.FC<IEmailArticleProps> = (props) => {
  const { title, link } = props;
  const modifiedTitle = encodeURIComponent(title);
  const articleUrl = link;
  const hrefTextForEmailArticleLink = `mailto:?subject=${modifiedTitle}&body=${modifiedTitle} ${articleUrl}`;

  const onClickEmailAnalyticsHandler = () => {
    const newWindow = window.open(
      hrefTextForEmailArticleLink,
      '_blank',
      'noopener,noreferrer'
    );
    newWindow?.focus();
    triggerAnalyticsEvent(constant.trackingMessage);
  };

  const getClassName = getClassNameFactory(EmailArticle.displayName);

  return (
    <div className={getClassName()}>
      <span className={getClassName({ descendantName: 'buttonBlock' })}>
        <Button
          kind={ButtonKind.BUTTON}
          color={ButtonColor.SECONDARY}
          onClick={onClickEmailAnalyticsHandler}
          data-testid="emailLink"
          iconPosition={IconPosition.LEFT}
          icon={<EmailArticleIcon />}
          newWindow={true}
        >
          {constant.emailArticleButtonText}
        </Button>
      </span>
    </div>
  );
};

EmailArticle.displayName = 'EmailArticle';
